import type { SerpBannerConfig } from '../types';

const mobileTourSearchConfig = {
    fixed: [
        { id: 'cashback', cardIndex: 1 },
        { id: 'adfox',    cardIndex: 4 },
    ],
    queue: [
        { id: 'assistantSales', priority: 0, repeatMode: 'repeat' },
        { id: 'appInstall',     priority: 1, repeatMode: 'repeat' },
        { id: 'learnDiscount', priority: 2, repeatMode: 'repeat' },
        { id: 'dreamTour',     priority: 3, repeatMode: 'repeat' },
        { id: 'hacks8',        priority: 4, repeatMode: 'repeat' },
        { id: 'subscribe',     priority: 5, repeatMode: 'once' },
        { id: 'tourIncludes',  priority: 6, repeatMode: 'repeat' },
    ],
} as const satisfies SerpBannerConfig;

export default mobileTourSearchConfig;
